import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { stripPublicPrefix } from "./lib/site";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    // Internal navigation is full-page (<a href> everywhere), so each visit is a fresh
    // document load. TanStack still records/restores scroll across loads via sessionStorage,
    // but its cache key can't tell a back/forward navigation apart from a fresh link to a
    // URL that happens to have a cached position — so direct links would wrongly restore.
    // Gate restoration on the browser's own navigation-type signal: only restore on
    // history traversal (back/forward) and reloads; fresh navigations start at the top.
    scrollRestoration: () => {
      if (typeof window === "undefined") return true;
      const [nav] = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
      return nav?.type === "back_forward" || nav?.type === "reload";
    },
    defaultPreloadStaleTime: 0,
    rewrite: {
      input: ({ url }) => {
        url.pathname = stripPublicPrefix(url.pathname);
        return url;
      },
    },
  });

  return router;
};
